import logo from './logo.svg';
import './App.css';
import HomePage from './pages/Home/HomePage'
import IconeWhatsApp from './sections/IconeWhatsApp';
import Hedaer from './sections/Header';
import Footer from './sections/Footer';

function App() {
  return (
    <div className="App">
      <Hedaer />
      <HomePage />
      <IconeWhatsApp />
      <Footer />
    </div>
  );
}

export default App;
